<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent :max-width="dialoWidth ? dialoWidth : 450">
      <v-card>
        <v-card-title>
          <v-btn class="mt-2" absolute left depressed  fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="confirm_form" data-vv-scope="confirm_form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-icon size="150" :color="type ? typeColors[type] : 'error'" class="">{{ type === 'success' ? 'check_circle' : 'error_outline'}}</v-icon>
              </v-flex>
              <v-flex xs12 text-xs-center headline>
                {{ message ? message : typeTexts[type] ? typeTexts[type] : '' }}
              </v-flex>
              <!-- <v-flex xs12 text-xs-center subheading mt-3>
                {{ confirmText }}
              </v-flex> -->
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="" flat @click="dialog = false">Cancel</v-btn> -->
          <v-btn :color="type ? typeColors[type] : 'error'" @click="dialog = false" :loading="loading" :disabled="loading">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'PaymentMessageModal',
  props: ['paymentMessageDialog', 'loading', 'type', 'message', 'dialoWidth'],
  data () {
    return {
      dialog: this.paymentMessageDialog,
      typeTexts: {
        error: 'Sorry! An error occurred during the transaction.',
        cancel: 'The transaction was canceled',
        success: 'Thank you! You successfully paid your package.'
      },
      typeColors: {
        error: 'error',
        cancel: 'warning',
        success: 'success'
      }
    }
  },
  watch: {
    paymentMessageDialog: {
      handler () {
        this.dialog = this.paymentMessageDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('paymentMessageDialog', this.dialog)
      }
    }
  },
  methods: {
    confirm () {
      this.$parent.$emit('confirmAction', this.param)
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/subscriptions/PaymentMessageModal.vue